import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// Debug-Logging
if (window.rbsAjax?.debug) {
  console.log('Restaurant Booking System: Initialisierung gestartet');
  console.log('rbsAjax Objekt:', window.rbsAjax);
}

// WordPress Integration: App nur rendern wenn Container existiert
const container = document.getElementById('restaurant-booking-app');

if (container) {
  if (window.rbsAjax?.debug) {
    console.log('Restaurant Booking System: Container gefunden, React-App wird gerendert');
  }
  
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Restaurant Booking System: Container mit ID "restaurant-booking-app" nicht gefunden!');
  
  // Hilfreiche Debug-Informationen
  console.log('Verfügbare DOM-Elemente mit "restaurant" im Namen:');
  document.querySelectorAll('[id*="restaurant"], [class*="restaurant"]').forEach(el => {
    console.log('- Element:', el.tagName, 'ID:', el.id, 'Class:', el.className);
  });
} 